/**
 * Flights Autosuggest API Contract
 *
 * Schema and types for the flights autosuggest API
 */
import * as v from 'valibot';

// ============================================================================
// Autosuggest Request Schema
// ============================================================================

export const AutosuggestRequestSchema = v.object({
  query: v.string(),
});

export type AutosuggestRequest = v.InferOutput<typeof AutosuggestRequestSchema>;

// ============================================================================
// Autosuggest Response Schemas
// ============================================================================

/**
 * Individual suggestion item from the API
 * Using looseObject to allow additional fields from API
 */
export const AutosuggestItemSchema = v.looseObject({
  iata: v.string(),
  cityName: v.string(),
  airportName: v.string(),
  country: v.string(),
  countryCode: v.string(),
  group_type: v.optional(v.string()),
  groupData: v.optional(
    v.array(
      v.looseObject({
        iata: v.string(),
        cityName: v.string(),
        airportName: v.string(),
        country: v.string(),
        countryCode: v.string(),
        group_type: v.string(),
      }),
    ),
  ),
});

export type AutosuggestItem = v.InferOutput<typeof AutosuggestItemSchema>;

/**
 * API response structure
 * Using looseObject to allow additional fields from API
 */
export const AutosuggestResponseSchema = v.looseObject({
  results: v.object({
    SUGGESTIONS: v.looseObject({
      title: v.optional(v.string()),
      data: v.array(AutosuggestItemSchema),
    }),
  }),
  sectionsOrder: v.optional(v.record(v.string(), v.number())),
});

export type AutosuggestResponse = v.InferOutput<typeof AutosuggestResponseSchema>;

// ============================================================================
// Location Suggestion (UI-ready format)
// ============================================================================

/**
 * UI-ready location suggestion
 * This is the format expected by the LocationInput component
 */
export const LocationSuggestionSchema = v.object({
  id: v.string(),
  city: v.string(),
  airportName: v.string(),
  iataCode: v.string(),
  country: v.string(),
  displayText: v.string(),
});

export type LocationSuggestion = v.InferOutput<typeof LocationSuggestionSchema>;
